<template>
  <div class="container">
    <div class="en-home">
      <div class="en-home-img">
        <div class="en-home-img-lack">
          <div class="e-h-i-l-content">
            <h2 class="e-h-i-l-title">播聘企业服务</h2>
            <div class="e-h-i-l-value">高效的一站式招聘服务平台</div>
          </div>
        </div>
        <div class="en-home-img-circle">
          <div class="en-home-img-centent">
            <div class="e-h-i-c-list">
              <dl>
                <dt><img src="../../../static/enter_1.png" alt="" /></dt>
                <dd class="e-h-i-c-money">39600000+</dd>
                <dd class="e-h-i-c-label">求职用户</dd>
              </dl>
            </div>
            <div class="e-h-i-c-list e-h-i-c-list-1">
              <dl>
                <dt><img src="../../../static/enter_2.png" alt="" /></dt>
                <dd class="e-h-i-c-money">1320000+</dd>
                <dd class="e-h-i-c-label">招聘企业</dd>
              </dl>
            </div>
            <div class="e-h-i-c-list">
              <dl>
                <dt><img src="../../../static/enter_3.png" alt="" /></dt>
                <dd class="e-h-i-c-money">70000+</dd>
                <dd class="e-h-i-c-label">合作商户</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <div class="en-home-body">
        <h2 class="en-home-body-h en-home-body-h-1">
          招聘与灵活用工服务，我们是专业的
        </h2>
        <h4 class="en-home-body-h4 en-home-body-h4-1">
          海量人才 &nbsp;&nbsp;/&nbsp;&nbsp; 精准匹配 &nbsp;&nbsp;/&nbsp;&nbsp;
          用心服务 &nbsp;&nbsp;/&nbsp;&nbsp; 提升效率
        </h4>
        <div class="en-home-body-list">
          <div class="en-home-body-item" v-for="(s, i) in enter" :key="i">
            <div class="e-h-b-i-img"><img :src="s.img" alt="" /></div>
            <div class="e-h-b-i-view">
              <div class="e-h-b-i-label">{{ s.title }}</div>
              <div class="e-h-b-i-value">{{ s.sub_title }}</div>
              <div>
                <button class="e-h-b-i-btn" @click="navgoTo(s)" type="button">
                  了解更多
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="en-home-body-list">
          <div class="en-home-body-item" v-for="(s, i) in enter1" :key="i">
            <div class="e-h-b-i-img"><img :src="s.img" alt="" /></div>
            <div class="e-h-b-i-view">
              <div class="e-h-b-i-label">{{ s.title }}</div>
              <div class="e-h-b-i-value">{{ s.sub_title }}</div>
              <div>
                <button class="e-h-b-i-btn" @click="navgoTo(s)" type="button">
                  了解更多
                </button>
              </div>
            </div>
          </div>
        </div>
        <h2 class="en-home-body-h en-home-body-h-2">百万家企业 共同选择播聘</h2>

        <div class="en-home-body-enter">
          <div class="en-home-body-enter-list" v-for="(s, i) in list" :key="i">
            <div class="en-home-body-enter-title">{{ s.title }}</div>
            <div class="en-home-body-enter-img">
              <img :src="s.img" alt="" />
            </div>
          </div>
        </div>

        <div class="en-home-body-handle">
          <button
            class="en-home-body-btn"
            @click="navgoTo({ path: `/enterprise-case` })"
            type="button"
          >
            查看更多客户案例
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EnterpriseHome",
  data() {
    return {
      enter: [
        {
          title: "在线招聘服务",
          sub_title: "数千万人才简历精准匹配",
          img: "../../../static/line.png",
          path: "/enterprise-server"
        },
        {
          title: "短工招聘服务",
          sub_title: "个人临时用工服务",
          img: "../../../static/short_time.png",
          path: "/enterprise-server-two"
        }
      ],
      enter1: [
        {
          title: "RPO招聘服务",
          sub_title: "专业招聘团队让招聘一步到位",
          img: "../../../static/RPO.png",
          path: "/enterprise-server-one"
        },
        {
          title: "企业增值服务",
          sub_title: "视频面试/视频会议/网络课堂等",
          img: "../../../static/Group2.png",
          path: "/enterprise-server-three"
        }
      ],
      list: [
        {
          title: "零售快消",
          img: "../../../static/sale.png"
        },
        {
          title: "餐饮酒店",
          img: "../../../static/hotel.png"
        },
        {
          title: "数码电子",
          img: "../../../static/dight.png"
        },
        {
          title: "制造加工",
          img: "../../../static/machine.png"
        },
        {
          title: "金融证券",
          img: "../../../static/money.png"
        }
      ]
    };
  },
  methods: {
    navgoTo(s) {
      this.$nav(
        {
          path: s.path
        },
        this
      );
    }
  }
};
</script>

<style scoped="scoped">
@import url("./enterprise-home.css");
</style>



// WEBPACK FOOTER //
// src/pages/enterprise-home/enterprise-home.vue